import "./HomeAbout.scss";
import plusSignIcon from "../../../assets/icons/mobile-plus-sign.svg";
import { useEffect, useState, useRef } from "react";
import Slideshow from "../../templates/Slideshow/Slideshow";
import ImageGrid from "../../templates/ImageGrid/ImageGrid";

function About({ CLOUDFRONT_URL }) {
  const sectionRef = useRef(null);
  const [screenSize, setScreenSize] = useState("desktop");
  const [isMobile, setIsMobile] = useState(false);

  const imageSets = {
    mobile: [
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_mb/web-usgs-1.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_mb/web-hum-1.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_mb/web-usgs-2.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_mb/web-hum-2.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_mb/web-usgs-3.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_mb/web-hum-3.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_mb/web-usgs-4.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_mb/web-hum-4.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_mb/web-usgs-5.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_mb/web-hum-5.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_mb/web-usgs-6.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_mb/web-hum-6.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_mb/web-usgs-7.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_mb/web-hum-7.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_mb/web-usgs-8.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_mb/web-hum-8.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_mb/web-usgs-9.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_mb/web-hum-9.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_mb/web-usgs-10.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_mb/web-hum-10.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_mb/web-usgs-11.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_mb/web-hum-11.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_mb/web-usgs-12.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_mb/web-hum-12.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_mb/web-usgs-13.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_mb/web-hum-13.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_mb/web-usgs-14.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_mb/web-hum-14.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_mb/web-usgs-15.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_mb/web-hum-15.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_mb/web-usgs-16.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_mb/web-hum-16.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_mb/web-usgs-17.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_mb/web-hum-17.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_mb/web-usgs-18.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_mb/web-hum-18.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_mb/web-usgs-19.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_mb/web-usgs-20.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_mb/web-usgs-21.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_mb/web-usgs-22.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_mb/web-usgs-23.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_mb/web-usgs-24.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_mb/web-usgs-25.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_mb/web-usgs-26.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_mb/web-usgs-27.jpg`,
    ],
    large_mobile: [
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_lmb/web-usgs-1.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_lmb/web-hum-1.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_lmb/web-usgs-2.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_lmb/web-hum-2.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_lmb/web-usgs-3.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_lmb/web-hum-3.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_lmb/web-usgs-4.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_lmb/web-hum-4.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_lmb/web-usgs-5.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_lmb/web-hum-5.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_lmb/web-usgs-6.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_lmb/web-hum-6.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_lmb/web-usgs-7.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_lmb/web-hum-7.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_lmb/web-usgs-8.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_lmb/web-hum-8.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_lmb/web-usgs-9.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_lmb/web-hum-9.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_lmb/web-usgs-10.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_lmb/web-hum-10.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_lmb/web-usgs-11.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_lmb/web-hum-11.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_lmb/web-usgs-12.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_lmb/web-hum-12.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_lmb/web-usgs-13.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_lmb/web-hum-13.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_lmb/web-usgs-14.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_lmb/web-hum-14.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_lmb/web-usgs-15.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_lmb/web-hum-15.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_lmb/web-usgs-16.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_lmb/web-hum-16.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_lmb/web-usgs-17.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_lmb/web-hum-17.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_lmb/web-usgs-18.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_lmb/web-hum-18.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_lmb/web-usgs-19.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_lmb/web-usgs-20.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_lmb/web-usgs-21.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_lmb/web-usgs-22.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_lmb/web-usgs-23.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_lmb/web-usgs-24.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_lmb/web-usgs-25.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_lmb/web-usgs-26.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_lmb/web-usgs-27.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_lmb/web-usgs-28.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_lmb/web-usgs-29.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_lmb/web-usgs-30.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_lmb/web-usgs-31.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_lmb/web-usgs-32.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_lmb/web-usgs-33.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_lmb/web-usgs-34.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_lmb/web-usgs-35.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_lmb/web-usgs-36.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_lmb/web-usgs-37.jpg`,
    ],
    small_tablet: [
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_stb/web-usgs-1.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_stb/web-hum-1.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_stb/web-usgs-2.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_stb/web-hum-2.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_stb/web-usgs-3.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_stb/web-hum-3.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_stb/web-usgs-4.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_stb/web-hum-4.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_stb/web-usgs-5.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_stb/web-hum-5.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_stb/web-usgs-6.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_stb/web-hum-6.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_stb/web-usgs-7.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_stb/web-hum-7.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_stb/web-usgs-8.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_stb/web-hum-8.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_stb/web-usgs-9.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_stb/web-hum-9.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_stb/web-usgs-10.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_stb/web-hum-10.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_stb/web-usgs-11.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_stb/web-hum-11.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_stb/web-usgs-12.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_stb/web-hum-12.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_stb/web-usgs-13.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_stb/web-hum-13.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_stb/web-usgs-14.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_stb/web-hum-14.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_stb/web-usgs-15.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_stb/web-hum-15.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_stb/web-usgs-16.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_stb/web-hum-16.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_stb/web-usgs-17.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_stb/web-hum-17.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_stb/web-usgs-18.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_stb/web-hum-18.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_stb/web-usgs-19.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_stb/web-usgs-20.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_stb/web-usgs-21.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_stb/web-usgs-22.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_stb/web-usgs-23.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_stb/web-usgs-24.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_stb/web-usgs-25.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_stb/web-usgs-26.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_stb/web-usgs-27.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_stb/web-usgs-28.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_stb/web-usgs-29.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_stb/web-usgs-30.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_stb/web-usgs-31.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_stb/web-usgs-32.jpg`,
    ],
    tablet: [
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_tb/web-usgs-1.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_tb/web-hum-1.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_tb/web-usgs-2.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_tb/web-hum-2.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_tb/web-usgs-3.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_tb/web-hum-3.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_tb/web-usgs-4.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_tb/web-hum-4.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_tb/web-usgs-5.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_tb/web-hum-5.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_tb/web-usgs-6.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_tb/web-hum-6.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_tb/web-usgs-7.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_tb/web-hum-7.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_tb/web-usgs-8.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_tb/web-hum-8.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_tb/web-usgs-9.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_tb/web-hum-9.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_tb/web-usgs-10.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_tb/web-hum-10.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_tb/web-usgs-11.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_tb/web-hum-11.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_tb/web-usgs-12.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_tb/web-hum-12.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_tb/web-usgs-13.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_tb/web-hum-13.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_tb/web-usgs-14.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_tb/web-hum-14.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_tb/web-usgs-15.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_tb/web-hum-15.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_tb/web-usgs-16.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_tb/web-hum-16.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_tb/web-usgs-17.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_tb/web-hum-17.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_tb/web-usgs-18.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_tb/web-hum-18.png`,
    ],
    desktop: [
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_sm/web-usgs-1.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_sm/web-hum-1.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_sm/web-usgs-2.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_sm/web-hum-2.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_sm/web-usgs-3.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_sm/web-hum-3.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_sm/web-usgs-4.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_sm/web-hum-4.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_sm/web-usgs-5.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_sm/web-hum-5.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_sm/web-usgs-6.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_sm/web-hum-6.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_sm/web-usgs-7.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_sm/web-hum-7.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_sm/web-usgs-8.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_sm/web-hum-8.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_sm/web-usgs-9.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_sm/web-hum-9.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_sm/web-usgs-10.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_sm/web-hum-10.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_sm/web-usgs-11.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_sm/web-hum-11.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_sm/web-usgs-12.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_sm/web-hum-12.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_sm/web-usgs-13.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_sm/web-hum-13.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_sm/web-usgs-14.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_sm/web-hum-14.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_sm/web-usgs-15.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_sm/web-hum-15.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_sm/web-usgs-16.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_sm/web-hum-16.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_sm/web-usgs-17.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_sm/web-hum-17.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_sm/web-usgs-18.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_sm/web-hum-18.png`,
    ],
    medium_desktop: [
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_md/web-usgs-1.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_md/web-hum-1.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_md/web-usgs-2.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_md/web-hum-2.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_md/web-usgs-3.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_md/web-hum-3.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_md/web-usgs-4.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_md/web-hum-4.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_md/web-usgs-5.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_md/web-hum-5.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_md/web-usgs-6.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_md/web-hum-6.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_md/web-usgs-7.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_md/web-hum-7.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_md/web-usgs-8.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_md/web-hum-8.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_md/web-usgs-9.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_md/web-hum-9.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_md/web-usgs-10.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_md/web-hum-10.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_md/web-usgs-11.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_md/web-hum-11.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_md/web-usgs-12.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_md/web-hum-12.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_md/web-usgs-13.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_md/web-hum-13.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_md/web-usgs-14.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_md/web-hum-14.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_md/web-usgs-15.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_md/web-hum-15.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_md/web-usgs-16.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_md/web-hum-16.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_md/web-usgs-17.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_md/web-hum-17.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_md/web-usgs-18.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_md/web-hum-18.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_md/web-usgs-19.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_md/web-usgs-20.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_md/web-usgs-21.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_md/web-usgs-22.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_md/web-usgs-23.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_md/web-usgs-24.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_md/web-usgs-25.jpg`,
    ],
    large_desktop: [
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_lg/web-usgs-1.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_lg/web-hum-1.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_lg/web-usgs-2.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_lg/web-hum-2.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_lg/web-usgs-3.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_lg/web-hum-3.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_lg/web-usgs-4.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_lg/web-hum-4.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_lg/web-usgs-5.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_lg/web-hum-5.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_lg/web-usgs-6.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_lg/web-hum-6.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_lg/web-usgs-7.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_lg/web-hum-7.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_lg/web-usgs-8.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_lg/web-hum-8.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_lg/web-usgs-9.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_lg/web-hum-9.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_lg/web-usgs-10.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_lg/web-hum-10.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_lg/web-usgs-11.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_lg/web-hum-11.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_lg/web-usgs-12.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_lg/web-hum-12.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_lg/web-usgs-13.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_lg/web-hum-13.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_lg/web-usgs-14.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_lg/web-hum-14.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_lg/web-usgs-15.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_lg/web-hum-15.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_lg/web-usgs-16.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_lg/web-hum-16.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_lg/web-usgs-17.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_lg/web-hum-17.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_lg/web-usgs-18.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/hum-sat-images/imagegrid_lg/web-hum-18.png`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_lg/web-usgs-19.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_lg/web-usgs-20.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_lg/web-usgs-21.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_lg/web-usgs-22.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_lg/web-usgs-23.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_lg/web-usgs-24.jpg`,
      `${CLOUDFRONT_URL}/about-images/grid-images/usgs-sat-images/imagegrid_lg/web-usgs-25.jpg`,
    ],
  };

  // Add window resize listener
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 425) {
        setScreenSize("mobile");
        setIsMobile(true);
      } else if (window.innerWidth < 576) {
        setScreenSize("large_mobile");
        setIsMobile(true);
      } else if (window.innerWidth < 768) {
        setScreenSize("small_tablet");
        setIsMobile(true);
      } else if (window.innerWidth < 1024) {
        setScreenSize("tablet");
        setIsMobile(false);
      } else if (window.innerWidth < 1440) {
        setScreenSize("desktop");
        setIsMobile(false);
      } else if (window.innerWidth < 1920) {
        setScreenSize("medium_desktop");
        setIsMobile(false);
      } else {
        setScreenSize("large_desktop");
        setIsMobile(false);
      }
    };

    // Set initial size
    handleResize();

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const observerOptions = {
      // Track when element is halfway (0.5) in viewport
      threshold: 0.5,
      // Add root margin to trigger exit animation earlier
      // This creates a virtual boundary 50% down from the top of the viewport
      rootMargin: "-50% 0px 0px 0px",
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const bitmaps = entry.target.querySelectorAll(".about__bitmap");

        if (entry.isIntersecting) {
          // Element has crossed the 50% visibility threshold coming into view
          bitmaps.forEach((bitmap, index) => {
            bitmap.classList.remove(`exit--${index + 1}`);
            bitmap.classList.add(`enter--${index + 1}`);
          });
        } else {
          // Element has crossed the 50% visibility threshold going out of view
          bitmaps.forEach((bitmap, index) => {
            bitmap.classList.remove(`enter--${index + 1}`);
            bitmap.classList.add(`exit--${index + 1}`);
          });
        }
      });
    }, observerOptions);

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <div className="about" ref={sectionRef}>
      <div className="about__grid"></div>
      <div className="about__bitmaps">
        <img
          className="about__bitmap about__bitmap--1"
          src={
            isMobile
              ? `${CLOUDFRONT_URL}/about-images/bitmaps/mobile/about-bitmap-1.svg`
              : `${CLOUDFRONT_URL}/about-images/bitmaps/desktop/about-bitmap-1.svg`
          }
          alt="bitmap image"
        />
        <img
          className="about__bitmap about__bitmap--2"
          src={
            isMobile
              ? `${CLOUDFRONT_URL}/about-images/bitmaps/mobile/about-bitmap-2.svg`
              : `${CLOUDFRONT_URL}/about-images/bitmaps/desktop/about-bitmap-2.svg`
          }
          alt="bitmap image"
        />
        <img
          className="about__bitmap about__bitmap--3"
          src={
            isMobile
              ? `${CLOUDFRONT_URL}/about-images/bitmaps/mobile/about-bitmap-3.svg`
              : `${CLOUDFRONT_URL}/about-images/bitmaps/desktop/about-bitmap-3.svg`
          }
          alt="bitmap image"
        />
      </div>
      <div className="about__content">
        <div className="about__title-card-container about__title-card-container--1">
          <img
            className="about__plus-sign"
            src={plusSignIcon}
            alt="plus sign"
          />
          <img
            className="about__plus-sign"
            src={plusSignIcon}
            alt="plus sign"
          />
          <img
            className="about__plus-sign"
            src={plusSignIcon}
            alt="plus sign"
          />
          <img
            className="about__plus-sign"
            src={plusSignIcon}
            alt="plus sign"
          />
          <div className="about__title-card">our ambition</div>
        </div>
        <div className="about__info-card-container about__info-card-container--1">
          <div className="about__info-card about__info-card--text">
            <div className="about__info-card--text--title">
              general intelligence
            </div>
            <div className="about__info-card--text--subtitle">
              of the physical world
            </div>
          </div>
          <div className="about__info-card about__info-card--image">
            <Slideshow
              CLOUDFRONT_URL={CLOUDFRONT_URL}
              interval={4000}
              className="about__slideshow"
            />
          </div>
        </div>
        <div className="about__title-card-container about__title-card-container--2">
          <img
            className="about__plus-sign"
            src={plusSignIcon}
            alt="plus sign"
          />
          <img
            className="about__plus-sign"
            src={plusSignIcon}
            alt="plus sign"
          />
          <img
            className="about__plus-sign"
            src={plusSignIcon}
            alt="plus sign"
          />
          <img
            className="about__plus-sign"
            src={plusSignIcon}
            alt="plus sign"
          />
          <div className="about__title-card">we're training on</div>
        </div>
        <div className="about__info-card-container about__info-card-container--2">
          <div className="about__info-card about__info-card--text">
            <div className="about__info-card--text--title">
              thousands of terabytes
            </div>
            <div className="about__info-card--text--subtitle">
              of satellite imagery
            </div>
          </div>
          <div className="about__info-card about__info-card--image">
            <ImageGrid
              images={imageSets[screenSize]}
              className="about__image-grid"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default About;
